import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'LAUDO_OFICINA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('laudoOficinaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/laudoOficina`)
		.then(resp => {
			dispatch({
		        type: 'LAUDO_OFICINA_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaFronteira() {
	return (dispatch, getState) => {
	
    	axios.get(`${consts.API_URL}/reports/fronteiras`)
		.then(resp => {
			dispatch({
		        type: 'LAUDO_OFICINA_FRONTEIRA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
		});
	}
}

export function getListaOperacao() {
	return (dispatch, getState) => {
	
    	axios.get(`${consts.API_URL}/operacao/listarSelect`)
		.then(resp => {
			dispatch({
		        type: 'LAUDO_OFICINA_OPERACAO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
		});
	}
}

export function getListaCidade() {
	return (dispatch, getState) => {
	
    	axios.get(`${consts.API_URL}/reports/cidade`)
		.then(resp => {
			dispatch({
		        type: 'LAUDO_OFICINA_CIDADE_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/laudoOficina`, {
				...registro,
				limite: FormatUtils.formatarValorBanco(registro.limite, 2),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/laudoOficina`, {
				...registro,
				limite: FormatUtils.formatarValorBanco(registro.limite, 2),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/laudoOficina?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
